import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { lazy } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { NotFoundPage } from 'libs.react';
const UsersDashboardPage = lazy(() => import('./components/users_dashboard'));
const UserView = lazy(() => import('./components/user_view'));
export const UserManagementApp = () => {
    const navigate = useNavigate();
    return (_jsxs(Routes, { children: [_jsx(Route, { index: true, path: 'dashboard', element: _jsx(UsersDashboardPage, {}) }), _jsx(Route, { index: true, path: ':id', element: _jsx(UserView, {}) }), _jsx(Route, { path: '*', element: _jsx(NotFoundPage, { goBack: () => navigate(-1) }) })] }));
};
export { USER_MANAGEMENT_FLAGS } from './constants/developer_flags.constants';
